import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import aiImage from '../assets/locate.png';
import locate from '../assets/matching.png';
import nots from '../assets/nots.png';
import community from '../assets/community.png';
import './features.css'

const Features = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true
    });
  }, []);

  return (
    <div className="featureBody">
      <div className="featureHeader">
        <h1 data-aos="fade-up">How TailTrace Works</h1>
        <p className="featureSubheader" data-aos="fade-up" data-aos-delay="50">
          From scan to reunion our AI does the heavy lifting so you can focus on finding your pet.
        </p>
      </div>
      <div className="featureIcons">
        <div className="textIcon" data-aos="fade-up">
          <img className='featureImages' src={aiImage} alt="AI-powered pet scanning"/>
          <div className="featureText">
            <h3>AI Powered Scanning</h3>
            <p>Snap a photo of a pet you've found or upload one of your missing companion. Our AI analyzes unique features like breed, markings, and color to build a detailed profile.</p>
          </div>
        </div>
        <div className="textIcon" data-aos="fade-up" data-aos-delay="100">
          <img className='featureImages' src={locate} alt="Scan comparison and matching"/>
          <div className="featureText">
            <h3>Scan Comparison & Matching</h3>
            <p>TailTrace compares your pet's scan against all reported lost and found pets in the database, surfacing the closest matches with a similarity score so you can verify quickly.</p>
          </div>
        </div>
        <div className="textIcon" data-aos="fade-up" data-aos-delay="200">
          <img className='featureImages' src={nots} alt="Geolocation alerts"/>
          <div className="featureText">
            <h3>Location Based Alerts</h3>
            <p>Get notified instantly when a pet matching your lost companion is reported nearby. Our geolocation system tracks lost pets in your area so you never miss a potential sighting.</p>
          </div>
        </div>
        <div className="textIcon" data-aos="fade-up" data-aos-delay="300">
          <img className='featureImages' src={community} alt="Community posting"/>
          <div className="featureText">
            <h3>Community Network</h3>
            <p>Post about lost or found pets, browse sightings on an interactive map, and connect with pet owners in your neighborhood. Report and block features keep the community safe and trusted.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Features;